import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let summaryCache = null;
const listeners = new Set();

export const refreshReviewSummary = async () => {
  try {
    const r = await axios.get(`${API}/reviews/summary`);
    summaryCache = r.data;
    listeners.forEach((fn) => fn(summaryCache));
  } catch {
    // keep previous summary
  }
};

export const useReviewSummary = () => {
  const [summary, setSummary] = useState(summaryCache || {});
  useEffect(() => {
    listeners.add(setSummary);
    if (!summaryCache) refreshReviewSummary();
    return () => listeners.delete(setSummary);
  }, []);
  return summary;
};

export const useProductReviews = (productId) => {
  const [reviews, setReviews] = useState(null);
  const load = useCallback(() => {
    if (!productId) return;
    axios.get(`${API}/reviews`, { params: { product: productId } }).then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, [productId]);
  useEffect(load, [load]);
  return { reviews, reload: () => { load(); refreshReviewSummary(); } };
};
